import { CategoriaVincolo } from "../categoriaVincolo.model";


export class AppuntamentoFase2 {

  data!: Date;
  installazioneOK!:boolean;
  note!:string;
  causaFallimento!:string;


  indirizzoScuola!:string;
  comuneScuola!:string;
  backup!:boolean;

  serialNumber!:string;
  partNumber!:string;
   categoriaVincolo!: CategoriaVincolo;
}
  